export default function(fullName) {
    return fullName.match(
        /* /^[A-Za-z]([-']?[A-Za-z]+)*( [A-Za-z]([-']?[A-Za-z]+)*)+$/ */
        /^([A-Za-z]([-']?[A-Za-z]+ )*)+$/
    );
};
